module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKkAAAAMCAYAAAAZBJ1yAAAAAXNSR0IArs4c6QAAAThJREFUaEPtmTFPhTAUhU8pcSARQsPmT3BxUxdmBgcGNncn5cegk7sbA4MDMwu6vcWf4EYgYMJgKJiSx/AGTVyaJu/epeGG5By+nrShZdjXsiwnwzDcSSlvAZzv2x+c8xfXdZ8ZY9/buzQSAZ0EmBJrmubMsqxXABe/iO/meb4JguBTpznSIgKKAFMraNd1738EdCO1833/klZUCo5uAqzv+3sp5aMSnqYJRVGgqqrVRxiGiOMYtm2vz5zzB8/znnSbJL3jJsDatq0BXCkMeZ6jLMsDIlEUIUmSrfcmhLg+bmT09boJqJAOAE6VcJqmGMfxwIPjOMiybO1JKVHXKtNUREAfgX+FFMCXEMLVZ4+UiABA2z2lwHgC9ONk/BSRQTqCogwYT4AO842fIjK4hlQVXYtSGEwl8ANW4ZAi0yrvvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1